const STAGE = {
    CANVAS_WIDTH: 1920,
    CANVAS_HEIGHT: 1080,
    GROUND_HEIGHT: 174,
    SCENE_MAX_WIDTH: 3500
}

export default STAGE